import {
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-available-slots-dialog',
  templateUrl: './available-slots-dialog.component.html',
  styleUrl: './available-slots-dialog.component.scss',
})
export class AvailableSlotsDialogComponent {
  @Input() dialogTitle = '';
  @Input() hideCloseButton = false;
  @Input() customClass = '';
  @Output() closeClick = new EventEmitter<void>();

  constructor(@Optional() private dialogRef: MatDialogRef<unknown>) {}

  onCloseClick(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.closeClick.emit();
  }
}
